import { useController } from 'react-hook-form';
import { UncontrolledTextarea } from 'components/Form';
import { defaultDetail } from './VenueDetail';

const VenueDriverInstructionsEditMode = ({ fieldName, driverInstructions }) => {
  const { field } = useController({
    name: fieldName,
    defaultValue: driverInstructions,
    shouldUnregister: false,
  });

  return (
    <div className="field-container">
      <UncontrolledTextarea
        {...field}
        placeholder="Driver required to handle? Driver needs specefic equipment? etc."
        rows={5}
      />
    </div>
  );
};

const VenueDriverInstructionsRenderer = ({ value: driverInstructions, isEditing, fieldName }) => {
  if (isEditing) {
    return (
      <VenueDriverInstructionsEditMode
        fieldName={fieldName}
        driverInstructions={driverInstructions}
      />
    );
  }

  if (!driverInstructions) {
    return <>{defaultDetail}</>;
  }

  if (typeof driverInstructions !== 'string') {
    return <>{defaultDetail}</>;
  }

  return <>{driverInstructions}</>;
};

export default VenueDriverInstructionsRenderer;
